export default [
  {
    id: 50,
    value: '教育',
    children: [
      {
        id: 5000,
        value: '学前教育',
        children: [
          {
            id: 500001,
            value: '0-3岁训练'
          },
          {
            id: 500002,
            value: '3-6岁训练'
          }
        ]
      },
      {
        id: 5001,
        value: '中小学教育',
        children: [
          {
            id: 500101,
            value: '小学辅导'
          },
          {
            id: 500102,
            value: '初中辅导'
          },
          {
            id: 500103,
            value: '高中辅导'
          },
          {
            id: 500104,
            value: '艺考培训'
          }
        ]
      },
      {
        id: 5002,
        value: '学历教育',
        children: [
          {
            id: 500201,
            value: '专升本'
          },
          {
            id: 500202,
            value: '自考'
          },
          {
            id: 500203,
            value: '成人高考'
          },
          {
            id: 500204,
            value: '考研'
          },
          {
            id: 500205,
            value: '在职MBA'
          }
        ]
      },
      {
        id: 5003,
        value: '出国留学',
        children: [
          {
            id: 500301,
            value: '雅思/托福'
          },
          {
            id: 500302,
            value: '留学入学考试'
          },
          {
            id: 500303,
            value: '美国高考'
          },
          {
            id: 500304,
            value: '留学申请'
          },
          {
            id: 500305,
            value: '国际游学'
          }
        ]
      },
      {
        id: 5004,
        value: '语言培训',
        children: [
          {
            id: 500401,
            value: '少儿英语'
          },
          {
            id: 500402,
            value: '青少年英语'
          },
          {
            id: 500403,
            value: '四六级英语考试'
          },
          {
            id: 500404,
            value: '成人英语'
          },
          {
            id: 500405,
            value: '其他小语种'
          },
          {
            id: 500406,
            value: '对外汉语'
          }
        ]
      },
      {
        id: 5005,
        value: '职业技能培训',
        children: [
          {
            id: 500501,
            value: 'IT培训与考试'
          },
          {
            id: 500502,
            value: '公务员培训与考试'
          },
          {
            id: 500503,
            value: '财经考试'
          },
          {
            id: 500504,
            value: '医学资格培训与考试'
          },
          {
            id: 500505,
            value: '教师资格考试'
          },
          {
            id: 500506,
            value: '建造师资格考试'
          },
          {
            id: 500507,
            value: '厨师培训'
          },
          {
            id: 500509,
            value: '化妆培训'
          },
          {
            id: 500510,
            value: '消防工程师培训'
          },
          {
            id: 500511,
            value: '心理咨询师培训'
          },
          {
            id: 500513,
            value: '营养师培训'
          },
          {
            id: 500514,
            value: '影视剪辑培训'
          },
          {
            id: 500515,
            value: '健康管理师培训'
          },
          {
            id: 500516,
            value: '法律考试'
          }
        ]
      },
      {
        id: 5006,
        value: '文艺培训',
        children: [
          {
            id: 500601,
            value: '舞蹈培训'
          },
          {
            id: 500602,
            value: '少儿音乐'
          },
          {
            id: 500603,
            value: '少儿美术'
          }
        ]
      },
      {
        id: 5007,
        value: '体能培训'
      },
      {
        id: 5008,
        value: '家教'
      },
      {
        id: 5009,
        value: '企业培训'
      },
      {
        id: 5010,
        value: '少儿编程'
      },
      {
        id: 5011,
        value: '驾照考试'
      }
    ]
  },
  {
    id: 51,
    value: '房产',
    children: [
      {
        id: 5100,
        value: '房产中介',
        children: [
          {
            id: 510001,
            value: '二手房交易'
          },
          {
            id: 510002,
            value: '新房交易'
          },
          {
            id: 510003,
            value: '豪宅交易'
          },
          {
            id: 510004,
            value: '写字楼交易'
          },
          {
            id: 510005,
            value: '海外房产交易'
          },
          {
            id: 510006,
            value: '住宅租赁'
          },
          {
            id: 510007,
            value: '商业租赁'
          },
          {
            id: 510008,
            value: '房产资讯'
          }
        ]
      },
      {
        id: 5102,
        value: '房屋装修',
        children: [
          {
            id: 510201,
            value: '别墅装修'
          },
          {
            id: 510202,
            value: '小户型装修'
          },
          {
            id: 510203,
            value: '装修建材'
          }
        ]
      }
    ]
  },
  {
    id: 52,
    value: '游戏',
    children: [
      {
        id: 5201,
        value: '游戏（按题材）',
        children: [
          {
            id: 520101,
            value: '西游'
          },
          {
            id: 520102,
            value: '战争'
          },
          {
            id: 520103,
            value: '传奇'
          },
          {
            id: 520104,
            value: '历史'
          },
          {
            id: 520105,
            value: '仙侠'
          },
          {
            id: 520106,
            value: '小说'
          },
          {
            id: 520107,
            value: '二次元'
          },
          {
            id: 520108,
            value: '西方魔幻'
          },
          {
            id: 520109,
            value: '三国'
          }
        ]
      },
      {
        id: 5202,
        value: '游戏（按类型）',
        children: [
          {
            id: 520201,
            value: '休闲益智'
          },
          {
            id: 520202,
            value: '体育竞技'
          },
          {
            id: 520203,
            value: '动作'
          },
          {
            id: 520204,
            value: '卡牌'
          },
          {
            id: 520205,
            value: '在线棋牌'
          },
          {
            id: 520206,
            value: '射击'
          },
          {
            id: 520207,
            value: '角色扮演'
          },
          {
            id: 520208,
            value: '经营养成'
          },
          {
            id: 520209,
            value: '酷跑竞速'
          },
          {
            id: 520210,
            value: '模拟辅助'
          },
          {
            id: 520211,
            value: '宝石消除'
          },
          {
            id: 520212,
            value: '儿童游戏'
          },
          {
            id: 520213,
            value: '策略塔防'
          },
          {
            id: 520214,
            value: '格斗'
          }
        ]
      },
      {
        id: 5203,
        value: '游戏（按开发商）',
        children: [
          {
            id: 520301,
            value: '腾讯'
          },
          {
            id: 520302,
            value: '网易'
          },
          {
            id: 520303,
            value: '完美世界'
          },
          {
            id: 520304,
            value: '宝果科技'
          },
          {
            id: 520305,
            value: '搜狐畅游'
          },
          {
            id: 520306,
            value: '360'
          },
          {
            id: 520307,
            value: '3975'
          },
          {
            id: 520308,
            value: '诚品软件'
          }
        ]
      },
      {
        id: 5204,
        value: '游戏（按载体）',
        children: [
          {
            id: 520401,
            value: 'PC游戏'
          },
          {
            id: 520402,
            value: '手机游戏'
          },
          {
            id: 520403,
            value: '游戏机'
          },
          {
            id: 520404,
            value: '网页游戏'
          },
          {
            id: 520405,
            value: '网络游戏'
          }
        ]
      }
    ]
  },
  {
    id: 53,
    value: '汽车',
    children: [
      {
        id: 5301,
        value: '汽车（按类型）',
        children: [
          {
            id: 530101,
            value: 'MPV'
          },
          {
            id: 530102,
            value: 'SUV'
          },
          {
            id: 530103,
            value: '轿车'
          },
          {
            id: 530104,
            value: '皮卡'
          }
        ]
      },
      {
        id: 5302,
        value: '汽车（按动力）',
        children: [
          {
            id: 530201,
            value: '汽油'
          },
          {
            id: 530202,
            value: '新能源'
          }
        ]
      },
      {
        id: 5303,
        value: '汽车（按价格）',
        children: [
          {
            id: 530301,
            value: '低档车'
          },
          {
            id: 530302,
            value: '中档车'
          },
          {
            id: 530303,
            value: '高档车'
          },
          {
            id: 530304,
            value: '豪华车'
          }
        ]
      },
      {
        id: 5304,
        value: '汽车服务',
        children: [
          {
            id: 530401,
            value: '汽车保险'
          },
          {
            id: 530402,
            value: '汽车改装'
          },
          {
            id: 530403,
            value: '汽车用品'
          },
          {
            id: 530404,
            value: '汽车维修'
          },
          {
            id: 530405,
            value: '汽车美容'
          }
        ]
      },
      {
        id: 5305,
        value: '租车服务'
      },
      {
        id: 5306,
        value: '汽车商品'
      },
      {
        id: 5307,
        value: '二手汽车'
      },
      {
        id: 5308,
        value: '车展'
      },
      {
        id: 5309,
        value: '汽车金融',
        children: [
          {
            id: 530901,
            value: '二手车抵押'
          },
          {
            id: 530902,
            value: '购车贷款'
          }
        ]
      },
      {
        id: 5310,
        value: '房车'
      }
    ]
  },
  {
    id: 54,
    value: '金融',
    children: [
      {
        id: 5401,
        value: '银行',
        children: [
          {
            id: 540101,
            value: '贷款'
          },
          {
            id: 540102,
            value: '信用卡'
          },
          {
            id: 540103,
            value: '理财'
          }
        ]
      },
      {
        id: 5402,
        value: '保险',
        children: [
          {
            id: 540201,
            value: '财险'
          },
          {
            id: 540202,
            value: '寿险'
          },
          {
            id: 540203,
            value: '疾病保险'
          }
        ]
      },
      {
        id: 5403,
        value: '证券',
        children: [
          {
            id: 540301,
            value: '期货'
          },
          {
            id: 540302,
            value: '股票'
          },
          {
            id: 540303,
            value: '基金'
          },
          {
            id: 540304,
            value: '债券'
          },
          {
            id: 540305,
            value: '贵金属'
          },
          {
            id: 540306,
            value: '外汇'
          }
        ]
      },
      {
        id: 5404,
        value: '信托'
      },
      {
        id: 5405,
        value: '彩票'
      },
      {
        id: 5406,
        value: '理财培训'
      }
    ]
  },
  {
    id: 55,
    value: '旅游',
    children: [
      {
        id: 5501,
        value: '国内游'
      },
      {
        id: 5502,
        value: '境外游'
      },
      {
        id: 5503,
        value: '交通票务',
        children: [
          {
            id: 550301,
            value: '飞机票'
          },
          {
            id: 550302,
            value: '火车票'
          },
          {
            id: 550303,
            value: '大巴票'
          },
          {
            id: 550304,
            value: '游轮票'
          }
        ]
      },
      {
        id: 5504,
        value: '景点票务'
      },
      {
        id: 5505,
        value: '酒店住宿',
        children: [
          {
            id: 550501,
            value: '高端酒店'
          },
          {
            id: 550502,
            value: '中端酒店'
          },
          {
            id: 550503,
            value: '经济酒店'
          }
        ]
      },
      {
        id: 5506,
        value: '签证'
      },
      {
        id: 5507,
        value: '主题旅游'
      },
      {
        id: 5508,
        value: '自驾游'
      },
      {
        id: 5509,
        value: '本地周边游'
      },
      {
        id: 5510,
        value: '户外探险'
      }
    ]
  },
  {
    id: 56,
    value: '招商加盟',
    children: [
      {
        id: 5601,
        value: '教育网络加盟'
      },
      {
        id: 5602,
        value: '食品保健品加盟'
      },
      {
        id: 5603,
        value: '酒水饮料加盟'
      },
      {
        id: 5604,
        value: '美容保健加盟'
      },
      {
        id: 5605,
        value: '生活服务加盟'
      },
      {
        id: 5606,
        value: '机械加盟'
      },
      {
        id: 5607,
        value: '家居建材加盟'
      },
      {
        id: 5608,
        value: '数码家电加盟'
      },
      {
        id: 5609,
        value: '教育培训加盟'
      },
      {
        id: 5610,
        value: '服装加盟'
      },
      {
        id: 5611,
        value: '干洗加盟'
      },
      {
        id: 5612,
        value: '餐饮加盟'
      },
      {
        id: 5614,
        value: '创业致富项目加盟'
      },
      {
        id: 5615,
        value: '网店转让'
      },
      {
        id: 5616,
        value: '家教辅导加盟'
      },
      {
        id: 5617,
        value: '早教加盟'
      },
      {
        id: 5618,
        value: '刷脸支付加盟'
      },
      {
        id: 5619,
        value: '种植养殖加盟'
      },
      {
        id: 5620,
        value: '手工活外发'
      }
    ]
  },
  {
    id: 57,
    value: '购物',
    children: [
      {
        id: 5701,
        value: '数码家电',
        children: [
          {
            id: 570101,
            value: '办公设备'
          },
          {
            id: 570102,
            value: '手机通讯'
          },
          {
            id: 570103,
            value: '电脑整机'
          },
          {
            id: 570104,
            value: '电脑配件'
          },
          {
            id: 570105,
            value: '摄影设备'
          },
          {
            id: 570106,
            value: '手机配件'
          },
          {
            id: 570107,
            value: '网络设备'
          },
          {
            id: 570108,
            value: '影音设备'
          },
          {
            id: 570109,
            value: '厨房电器'
          },
          {
            id: 570110,
            value: '大家电'
          },
          {
            id: 570111,
            value: '个人护理电器'
          }
        ]
      },
      {
        id: 5702,
        value: '服饰箱包',
        children: [
          {
            id: 570201,
            value: '时尚女装'
          },
          {
            id: 570202,
            value: '精品男装'
          },
          {
            id: 570203,
            value: '女鞋'
          },
          {
            id: 570204,
            value: '男鞋'
          },
          {
            id: 570205,
            value: '内衣'
          },
          {
            id: 570206,
            value: '珠宝配饰'
          },
          {
            id: 570207,
            value: '箱包皮具'
          },
          {
            id: 570208,
            value: '手表'
          },
          {
            id: 570209,
            value: '奢侈品'
          }
        ]
      },
      {
        id: 5703,
        value: '家具',
        children: [
          {
            id: 570301,
            value: '日用百货'
          },
          {
            id: 570302,
            value: '厨具餐具'
          },
          {
            id: 570305,
            value: '家具（+办公家具）'
          },
          {
            id: 570306,
            value: '家纺'
          },
          {
            id: 570307,
            value: '灯具'
          }
        ]
      },
      {
        id: 5704,
        value: '生鲜',
        children: [
          {
            id: 570401,
            value: '水果'
          },
          {
            id: 570402,
            value: '蔬菜'
          },
          {
            id: 570403,
            value: '肉品'
          },
          {
            id: 570404,
            value: '水产'
          }
        ]
      },
      {
        id: 5705,
        value: '盆栽'
      },
      {
        id: 5706,
        value: '农产品'
      },
      {
        id: 5707,
        value: '艺术品'
      },
      {
        id: 5708,
        value: '五金'
      },
      {
        id: 5709,
        value: '流量卡'
      }
    ]
  },
  {
    id: 58,
    value: '母婴亲子',
    children: [
      {
        id: 5801,
        value: '母婴食品',
        children: [
          {
            id: 580101,
            value: '奶粉'
          },
          {
            id: 580102,
            value: '辅食'
          }
        ]
      },
      {
        id: 5802,
        value: '母婴护理',
        children: [
          {
            id: 580201,
            value: '孕婴保健'
          },
          {
            id: 580202,
            value: '母婴护理服务'
          },
          {
            id: 580203,
            value: '纸尿裤湿巾'
          },
          {
            id: 580204,
            value: '产后护理'
          },
          {
            id: 580205,
            value: '宝宝护洗用户'
          },
          {
            id: 580206,
            value: '宝宝家电'
          },
          {
            id: 580207,
            value: '宝宝安全'
          },
          {
            id: 580208,
            value: '宝宝玩乐'
          },
          {
            id: 580209,
            value: '妈妈用品'
          },
          {
            id: 580210,
            value: '胎教'
          }
        ]
      },
      {
        id: 5803,
        value: '儿童用品',
        children: [
          {
            id: 580301,
            value: '童装童鞋'
          },
          {
            id: 580302,
            value: '童车童床'
          },
          {
            id: 580303,
            value: '儿童摄影'
          },
          {
            id: 580304,
            value: '儿童玩具'
          }
        ]
      },
      {
        id: 5804,
        value: '母婴社区'
      },
      {
        id: 5805,
        value: '备孕'
      }
    ]
  },
  {
    id: 59,
    value: '医疗健康',
    children: [
      {
        id: 5901,
        value: '养生保健'
      },
      {
        id: 5902,
        value: '医疗器械'
      },
      {
        id: 5903,
        value: '医疗服务'
      },
      {
        id: 5904,
        value: '医疗机构'
      },
      {
        id: 5906,
        value: '疾病'
      },
      {
        id: 5907,
        value: '药品'
      },
      {
        id: 5908,
        value: '体检'
      },
      {
        id: 5909,
        value: '疗养院'
      },
      {
        id: 5910,
        value: '成人用品'
      },
      {
        id: 5911,
        value: '口腔健康'
      },
      {
        id: 5912,
        value: '近视矫正'
      }
    ]
  },
  {
    id: 60,
    value: '餐饮美食',
    children: [
      {
        id: 6001,
        value: '美食',
        children: [
          {
            id: 600101,
            value: '面包蛋糕'
          },
          {
            id: 600102,
            value: '休闲小食'
          },
          {
            id: 600103,
            value: '快餐'
          },
          {
            id: 600104,
            value: '火锅'
          },
          {
            id: 600105,
            value: '烧烤'
          },
          {
            id: 600106,
            value: '海鲜'
          }
        ]
      },
      {
        id: 6002,
        value: '酒水'
      },
      {
        id: 6003,
        value: '饮料'
      },
      {
        id: 6004,
        value: '烹饪和菜谱'
      }
    ]
  },
  {
    id: 61,
    value: '商务服务',
    children: [
      {
        id: 6101,
        value: '人员招聘'
      },
      {
        id: 6102,
        value: '会计审计'
      },
      {
        id: 6103,
        value: '公关服务'
      },
      {
        id: 6104,
        value: '安全安保'
      },
      {
        id: 6105,
        value: '广告服务'
      },
      {
        id: 6106,
        value: '法律咨询'
      },
      {
        id: 6107,
        value: '大宗货物物流'
      },
      {
        id: 6108,
        value: '移民中介'
      },
      {
        id: 6110,
        value: '机械器材'
      },
      {
        id: 6111,
        value: '农林牧渔'
      },
      {
        id: 6112,
        value: '商标注册'
      },
      {
        id: 6113,
        value: 'logo设计'
      },
      {
        id: 6114,
        value: '信用查询'
      },
      {
        id: 6115,
        value: '公司注册'
      },
      {
        id: 6116,
        value: '积分落户'
      }
    ]
  },
  {
    id: 62,
    value: '生活服务',
    children: [
      {
        id: 6201,
        value: '二手回收'
      },
      {
        id: 6202,
        value: '社交',
        children: [
          {
            id: 620201,
            value: '婚恋型'
          },
          {
            id: 620202,
            value: '交友型'
          }
        ]
      },
      {
        id: 6203,
        value: '婚庆服务'
      },
      {
        id: 6204,
        value: '家政服务',
        children: [
          {
            id: 620401,
            value: '月嫂'
          },
          {
            id: 620402,
            value: '保姆'
          },
          {
            id: 620403,
            value: '保洁'
          },
          {
            id: 620404,
            value: '搬家服务'
          }
        ]
      },
      {
        id: 6205,
        value: '摄影服务'
      },
      {
        id: 6206,
        value: '物业维修'
      },
      {
        id: 6207,
        value: '物流配送'
      },
      {
        id: 6208,
        value: '礼品鲜花',
        children: [
          {
            id: 620801,
            value: '礼品'
          },
          {
            id: 620802,
            value: '鲜花配送'
          }
        ]
      },
      {
        id: 6211,
        value: '老人护理'
      },
      {
        id: 6212,
        value: '月子中心'
      },
      {
        id: 6213,
        value: '情感咨询'
      }
    ]
  },
  {
    id: 63,
    value: '个护美容',
    children: [
      {
        id: 6301,
        value: '减肥瘦身'
      },
      {
        id: 6302,
        value: '整容整形'
      },
      {
        id: 6303,
        value: '护肤美妆',
        children: [
          {
            id: 630301,
            value: '彩妆'
          },
          {
            id: 630302,
            value: '护肤品'
          }
        ]
      },
      {
        id: 6304,
        value: '个人护理',
        children: [
          {
            id: 630401,
            value: '美发'
          },
          {
            id: 630402,
            value: '美甲'
          },
          {
            id: 630403,
            value: 'SPA美体'
          }
        ]
      },
      {
        id: 6305,
        value: '香水'
      },
      {
        id: 6306,
        value: '面部微整形'
      }
    ]
  },
  {
    id: 64,
    value: '软件应用',
    children: [
      {
        id: 6401,
        value: '办公学习'
      },
      {
        id: 6402,
        value: '系统工具'
      },
      {
        id: 6403,
        value: '社交通讯'
      },
      {
        id: 6404,
        value: '影音图像'
      },
      {
        id: 6405,
        value: '手机美化'
      },
      {
        id: 6406,
        value: '理财购物'
      },
      {
        id: 6407,
        value: '生活实用'
      },
      {
        id: 6408,
        value: '资讯阅读'
      },
      {
        id: 6409,
        value: '旅游出行'
      },
      {
        id: 6410,
        value: '母婴育儿'
      },
      {
        id: 6411,
        value: '应用市场'
      }
    ]
  },
  {
    id: 65,
    value: '文化娱乐',
    children: [
      {
        id: 6501,
        value: '动漫',
        children: [
          {
            id: 650101,
            value: '热血动漫'
          },
          {
            id: 650102,
            value: '动漫资讯'
          },
          {
            id: 650103,
            value: '国产动漫'
          },
          {
            id: 650104,
            value: '韩国动漫'
          },
          {
            id: 650105,
            value: '欧美动漫'
          },
          {
            id: 650106,
            value: '日本动漫'
          }
        ]
      },
      {
        id: 6502,
        value: '影视',
        children: [
          {
            id: 650201,
            value: '爱情'
          },
          {
            id: 650202,
            value: '家庭'
          },
          {
            id: 650203,
            value: '动作'
          },
          {
            id: 650204,
            value: '犯罪'
          },
          {
            id: 650205,
            value: '中国近代战争'
          },
          {
            id: 650206,
            value: '搞笑'
          },
          {
            id: 650207,
            value: '武侠'
          }
        ]
      },
      {
        id: 6503,
        value: '广播电台'
      },
      {
        id: 6504,
        value: '戏曲曲艺'
      },
      {
        id: 6505,
        value: '演出票务'
      },
      {
        id: 6506,
        value: '直播',
        children: [
          {
            id: 650601,
            value: '星娱'
          },
          {
            id: 650602,
            value: '游戏直播'
          },
          {
            id: 650603,
            value: '音乐直播'
          }
        ]
      },
      {
        id: 6507,
        value: '综艺'
      },
      {
        id: 6508,
        value: '音乐'
      },
      {
        id: 6509,
        value: 'KTV'
      },
      {
        id: 6510,
        value: '棋牌桌游'
      },
      {
        id: 6511,
        value: '收藏'
      },
      {
        id: 6512,
        value: '文化艺术'
      },
      {
        id: 6513,
        value: '书籍阅读'
      },
      {
        id: 6514,
        value: '星座运势'
      },
      {
        id: 6515,
        value: '休闲爱好'
      },
      {
        id: 6516,
        value: '网络小说',
        children: [
          {
            id: 651601,
            value: '都市爽文'
          },
          {
            id: 651602,
            value: '仙侠玄幻'
          },
          {
            id: 651603,
            value: '言情'
          }
        ]
      }
    ]
  },
  {
    id: 66,
    value: '资讯',
    children: [
      {
        id: 6601,
        value: '社会时政'
      },
      {
        id: 6602,
        value: '法制'
      },
      {
        id: 6603,
        value: '国际社会'
      },
      {
        id: 6604,
        value: '投资'
      },
      {
        id: 6605,
        value: '健康'
      },
      {
        id: 6606,
        value: '购房'
      },
      {
        id: 6607,
        value: '法律'
      },
      {
        id: 6608,
        value: '环保'
      },
      {
        id: 6609,
        value: '公益'
      },
      {
        id: 6610,
        value: '时装搭配'
      },
      {
        id: 6611,
        value: '汽车资讯'
      },
      {
        id: 6612,
        value: '生活资讯'
      },
      {
        id: 6613,
        value: '商业财经'
      },
      {
        id: 6614,
        value: '科技资讯'
      },
      {
        id: 6615,
        value: '娱乐八卦'
      },
      {
        id: 6616,
        value: '网络奇闻'
      },
      {
        id: 6617,
        value: '军事'
      },
      {
        id: 6618,
        value: '时尚'
      },
      {
        id: 6619,
        value: 'NBA'
      }
    ]
  },
  {
    id: 67,
    value: '体育健身',
    children: [
      {
        id: 6701,
        value: '球类运动'
      },
      {
        id: 6702,
        value: '休闲健身'
      },
      {
        id: 6703,
        value: '跑步骑行'
      },
      {
        id: 6704,
        value: '水上运动'
      },
      {
        id: 6705,
        value: '极限运动'
      },
      {
        id: 6706,
        value: '户外运动'
      },
      {
        id: 6707,
        value: '健身器械'
      },
      {
        id: 6708,
        value: '体育类赛事'
      },
      {
        id: 6709,
        value: '体育赛事票务'
      }
    ]
  }
]
